<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-view-suspensions-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'ViewSuspensions',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreViewSuspensionsView: () => import('../components/core/ViewSuspensionsView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
